import script from "./ServiceDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceDetailView.vue?vue&type=script&setup=true&lang=js"

import "./ServiceDetailView.vue?vue&type=style&index=0&id=016ee90d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-016ee90d"]])

export default __exports__